import { Link } from "react-router-dom";
import { trackSeoPageEvent, SEO_ANALYTICS_EVENTS } from "../../../constants/seoAnalyticsConstants";

export default function SeoBuyerGuidance() {
  return (
    <section className="seo-guidance" aria-labelledby="seo-guidance-heading">
      <h2 id="seo-guidance-heading">Antes de comprar</h2>
      <div className="seo-guidance__grid">
        <article>
          <h3>Compara con señales claras</h3>
          <p>Revisa precio comparable, kilometraje, año y badge de concesionario verificado.</p>
        </article>
        <article>
          <h3>Usa el checklist</h3>
          <p>Documentos, inspección mecánica y señales de riesgo antes de pagar.</p>
          <Link
            to="/guias/checklist-compra-carro-usado"
            onClick={() => trackSeoPageEvent(SEO_ANALYTICS_EVENTS.CHECKLIST_CLICKED, { source: "guidance" })}
          >
            Ver checklist
          </Link>
        </article>
        <article>
          <h3>¿No sabes por dónde empezar?</h3>
          <p>El quiz de compra te orienta según presupuesto, ciudad y uso.</p>
          <Link
            to="/v/automap/comprar/quiz"
            onClick={() => trackSeoPageEvent(SEO_ANALYTICS_EVENTS.BUYER_QUIZ_CLICKED, { source: "guidance" })}
          >
            Ayúdame a escoger
          </Link>
        </article>
      </div>
    </section>
  );
}
